// extracted by mini-css-extract-plugin
module.exports = {"bouncingImage":"Bouncing_bouncingImage__xaebP","smallerBounce":"Bouncing_smallerBounce__Ytaww"};